import React, { useState } from 'react';
import '../App.css';

const layers = [
  {
    title: '前端应用层',
    desc: '患者端（可穿戴设备/小程序/App）、健管师端（小程序/App/PC端）、医生端（小程序/App/PC端）、平台管理端（小程序/App/PC端）',
    color: '#2962ff',
  },
  {
    title: '平台服务层',
    desc: '拖拽式的表单设计、管理流程配置、Prompt工程化引擎、智能随访策略引擎、健康档案中心、AI算法服务、多租户管理、远程设备管理、内容分发与管理、数据分析与可视化等',
    color: '#2962ff',
  },
  {
    title: '后端数据层',
    desc: '多模态数据库、模型引擎、多租户数据存储与管理、按角色、组织配置功能与数据权限、数据安全与备份、数据脱敏与医学知识图谱',
    color: '#2962ff',
  },
];

const highlights = [
  { icon: '☁️', title: '混合云部署', desc: '支持本地与云端灵活部署，既保障核心数据的安全可控，又实现外部访问的高效便捷。' },
  { icon: '🤖', title: 'AI与大数据驱动', desc: '提供模型引擎与智能算法，持续挖掘数据价值，助力决策优化。' },
  { icon: '🧩', title: '微服务架构', desc: '高内聚、低耦合，采用模块化设计，各服务独立运行、协同高效，满足业务快速迭代。' },
  { icon: '🔀', title: '负载均衡', desc: '支持高可用与动态调度的可扩展架构。' },
  { icon: '🛡️', title: '多重安全保障', desc: '遵循行业安全标准，融合传输加密、权限控制、审计日志等多重机制，全面保障数据安全。' },
];

function TechArchitecture() {
  const isMobile = window.innerWidth < 900;
  const [open, setOpen] = useState([true, false, false]);
  const handleToggle = idx => setOpen(arr => arr.map((v, i) => i === idx ? !v : v));
  return (
    <section id="architecture">
      <h2 style={{marginBottom: 8}}>安全、稳定、智能</h2>
      <div style={{textAlign: 'center', color: '#003300', fontWeight: 700, fontSize: '1.25rem', marginBottom: 24}}>面向未来的技术基石</div>
      <div className="techarch-flex">
        <div className="techarch-layers">
          {layers.map((l, i) => (
            <div className="techarch-layer-card" key={i}>
              <div className="techarch-layer-title" style={{color: l.color, cursor: isMobile ? 'pointer' : 'default'}} onClick={() => isMobile && handleToggle(i)}>
                {l.title} {isMobile && <span style={{fontSize: 18, marginLeft: 6}}>{open[i] ? '▾' : '▸'}</span>}
              </div>
              {(!isMobile || open[i]) && <div className="techarch-layer-desc">{l.desc}</div>}
              {i < layers.length - 1 && <div className="techarch-layer-divider"></div>}
            </div>
          ))}
        </div>
        <div className="techarch-highlights">
          {highlights.map((h, i) => (
            <div className="techarch-highlight" key={i}>
              <span className="techarch-highlight-icon">{h.icon}</span>
              <div>
                <div className="techarch-highlight-title">{h.title}</div>
                <div className="techarch-highlight-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default TechArchitecture; 